import React, {useState} from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {css} from "styled-components/macro"; //eslint-disable-line
import {SectionHeading} from "components/misc/Headings.js";
import {SectionDescription} from "components/misc/Typography.js";
import {PrimaryButton as PrimaryButtonBase} from "components/misc/Buttons.js";
import {Container, ContentWithPaddingXl} from "components/misc/Layouts.js";
import {ReactComponent as SvgDecoratorBlob1} from "images/svg-decorator-blob-6.svg";
import {ReactComponent as SvgDecoratorBlob2} from "images/svg-decorator-blob-7.svg";


const PlanDurationSwitcher = tw.div`block w-full max-w-xs sm:inline-block sm:w-auto border-2 rounded-full px-1 py-1 mt-8`;
const SwitchButton = styled.button`
  ${tw`w-1/2 sm:w-32 px-4 sm:px-8 py-3 rounded-full focus:outline-none text-sm font-bold text-gray-700 transition duration-300`}
  ${props => props.active && tw`bg-primary-500 text-gray-100`}
`;

const HeaderContainer = tw.div`w-full flex flex-col items-center`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center`;

const PlansContainer = tw.div`flex justify-center flex-col lg:flex-row items-center lg:items-stretch relative`;
const Plan = styled.div`
  ${tw`w-full max-w-sm mt-16 lg:mr-8 lg:last:mr-0 text-center px-8 rounded-lg shadow relative py-8 text-gray-900 bg-white flex flex-col`}
  .planHighlight {
    ${tw`rounded-t-lg absolute top-0 inset-x-0 h-2`}
  }

  ${props =>
    props.featured &&
    css`
      background: rgb(100,21,255);
      background: linear-gradient(135deg, #C7942D 0%, rgba(128,64,252,1) 100%);
background: rgb(85,60,154);
background: linear-gradient(135deg, rgba(85,60,154,1) 0%, rgba(128,90,213,1) 100%);
background: rgb(76,81,191);
background: linear-gradient(135deg, #C7942D 0%, #DC9F5A 100%);
      ${tw`bg-primary-500 text-gray-100`}
      .planHighlight {
        ${tw`hidden`}
      }
      .duration {
        ${tw`text-gray-200!`}
      }
      ${PlanFeatures} {
        ${tw`border-indigo-500`}
      }
      .feature:not(.mainFeature) {
        ${tw`text-gray-300!`}
      }
      ${BuyNowButton} {
        ${tw`bg-gray-100 text-primary-500 hocus:bg-gray-300 hocus:text-primary-800`}
    `}
`;

const PlanHeader = styled.div`
  ${tw`flex flex-col uppercase leading-relaxed`}
  .name {
    ${tw`font-bold text-xl`}
  }
  .price {
    ${tw`font-bold text-4xl sm:text-5xl my-1`}
  }
  .duration {
    ${tw`text-gray-500 font-bold tracking-widest`}
  }
`;
const PlanFeatures = styled.div`
  ${tw`flex flex-col -mx-8 px-8 py-8 flex-1`}
  .feature {
    ${tw`mt-5 first:mt-0 font-medium`}
    &:not(.mainFeature) {
      ${tw`text-gray-600`}
    }
  }

`;

const PlanAction = tw.div`px-4 sm:px-8 xl:px-16 py-8`;
const BuyNowButton = styled(PrimaryButtonBase)`
  ${tw`rounded-full uppercase tracking-wider py-4 w-full text-sm hover:shadow-xl transform hocus:translate-x-px hocus:-translate-y-px focus:shadow-outline`}
`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-64 w-64 opacity-25 transform -translate-x-2/3 -translate-y-1/2`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-25 transform translate-x-2/3 translate-y-1/2 fill-current text-teal-300`}
`;

export default ({
  heading = "Flexible Plans",
  description = "",
  plans = null,
  primaryButtonText = "Buy Now",
  planDurations = [
    {
      text: "Month",
      switcherText: "Monthly",
    },
    {
      text: "Year",
      switcherText: "Yearly",
    }
  ]
}) => {
  const defaultPlans = [
    {
      desc: "Get Started Instantly",
      plan: "BASIC",
      features: [
        "MAI - Full control",
        "Dashboard",
        "PROMS - knee , shoulder, hip",
        "Can access historical data",
        "Max 20/mo Detailed Reports",
      ],
    },
    {
      desc: "Standard",
      durationPrices: ["£5","£48"],
      plan: "STANDARD",
      features: [
        "MAI - Full control",
        "Dashboard",
        "PROMS(Mandatory) - knee , shoulder, hip",
        "Can access historical data",
        "Dynamometer",
        "Unlimited Detailed Reports"
      ],
      featured: true
    },
    /*{
      name: "Advanced Plan",
      plan: "ADVANCED",
      durationPrices: ["£159.99","£1599.99"],
      features: [
         "MAI - advanced comparison function",
        "Dashboard",
        "PROMS - knee , shoulder, hip",
        "Can access historical data",
        "Digital Body Bank",
        "Dynamometer",
        "Unlimited Detailed Reports"
      ]
    }*/
  ];

  if (!plans) plans = defaultPlans;

  const [activeDurationIndex, setActiveDurationIndex] = useState(0);

  return (
    <Container>
      <ContentWithPaddingXl>
        <HeaderContainer>
          <Heading>{heading}</Heading>
          {description && <Description>{description}</Description>}
        <PlanDurationSwitcher>
          {planDurations.map((planDuration, index) => (
            <SwitchButton active={activeDurationIndex === index} key={index} onClick={() => setActiveDurationIndex(index)}>{planDuration.switcherText}</SwitchButton>
          ))}
        </PlanDurationSwitcher>
        </HeaderContainer>
        <PlansContainer>
          {plans.map((plan, index) => (
            <Plan key={index} featured={plan.featured}>
              {plan.plan !== "BASIC" && <PlanAction style={{ paddingTop: 0 }}>
                <BuyNowButton
                    onClick={() => window.open(plan.plan === "BASIC" ? `https://app.maimotion.com/register` :
                        `https://app.maimotion.com/buy-plan?plan=${plan.plan}&periodIndex=${activeDurationIndex}`)}
                >
                  CONTINUE FOR
                </BuyNowButton>
              </PlanAction>}
              <PlanHeader>
                {plan.plan !== "BASIC" ? <span className="priceAndDuration">
                  <span className="price">{plan.durationPrices[activeDurationIndex]}</span>
                  <span className="slash"> / </span>
                  <span className="duration">{planDurations[activeDurationIndex].text}</span>
                </span> : <span className="priceAndDuration"><span className="price">
                  Free Plan
                </span></span>}
                <span className="name">{plan.desc}</span>
              </PlanHeader>
              <PlanFeatures>
                {plan.plan !=="BASIC"  ? <span>
                  Get a customized plan, on hand Al
body expert and scan as frequently
as you want to start seeing real
results and changes in your body,
mobility and the way you move
                </span>: <span className="feature">
                  Get your first free body scan
and initial report for free today
so you can see you're weakness lie
                </span>}
              </PlanFeatures>
              <PlanAction style={{ paddingBottom: 0 }}>
                <BuyNowButton
                    onClick={() => window.open(plan.plan === "BASIC" ? `https://app.maimotion.com/register` :
                    `https://app.maimotion.com/buy-plan?plan=${plan.plan}&periodIndex=${activeDurationIndex}`)}
                >
                  {plan.plan === "BASIC" ? "Register Now" : "Buy Now"}
                </BuyNowButton>
              </PlanAction>
            </Plan>
          ))}
        </PlansContainer>
      </ContentWithPaddingXl>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
};
